<template>
    <v-container class="step-container" v-if="data.visible && unit && current">
        <inc-bid-zoom
            v-if   = "zoom"
            :bid   = "selected"
            :data  = "data"
            :form  = "form"
            @close = "onCloseZoom"
        />

        <v-row class="no-frame" style="position: relative">
            <div class="component-zoom-panel step-first-column" v-if="zoomComponents">
                <div class="component-close-button">
                    <c-toolbar-button
                        size     = "28"
                        color    = "red"
                        icon     = "mdi-close"
                        :tooltip = "$t('common.cancel')"
                        @click   = "zoomComponents = false"
                    />
                </div>

                <inc-components
                    v-model     = "current.components"
                    :site       = "unit"
                    :warranties = "warranties"
                    :incident   = "incident"
                    :status     = "status"
                    :height     = "525"
                    :zoom-allowed       = "false"
                    style       = "border-radius: 5px 0 5px 5px; margin-top: -1px"
                    @input      = "onComponents"
                    @zoom       = "onZoomComponents"
                    class       = "w-100 mt-2"
                />
            </div>

            <v-col class="step-first-column">

                <c-drop-message
                    v-if     = "drag.notAllowed"
                    :message = "drag.message"
                    style    = "margin-left: 0"
                />

                <drop class="cut h-100" @drop="onDrop" mode="cut" :accepts-type="onAcceptType" ref="droparea">
                    <div style="overflow-y: auto; width: calc(100% + 12px); max-height: 665px; height: 665px; padding-right: 3px">

                        <v-row class="no-frame mt-0" v-if="!isModernization">
                            <v-col class="no-frame col-6 pr-2" >
                                <inc-site-down-switch
                                    v-if      = "!previous"
                                    v-model   = "current.unitDown"
                                    class     = "mt-n1"
                                />
                            </v-col>
                            <v-col class="no-frame v-flex col-6 pl-2">
                                <v-switch
                                    v-if    = "!isFullMaintenance"
                                    v-model = "data.invoice"
                                    label   = "Rechnung"
                                    @change = "onInvoice"
                                    class   = "mt-0 mb-2 pt-0"
                                    :class  = "incident.warrenties? 'pr-7' : ''"
                                    :ripple = "false"
                                    hide-details
                                />

                                <v-switch
                                    v-if    = "isFullMaintenance"
                                    v-model = "current.notIncludedInFullMaintenance"
                                    label   = "nicht in Vollwartung "
                                    @change = "onNotIncludedInFullMaintenance"
                                    :ripple ="false"
                                    class   = "mt-0 mb-2 pt-0"
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-0" v-if="!isFullMaintenance">
                            <v-col class="no-frame col-6 pr-2" >
                            </v-col>
                            <v-col class="no-frame v-flex col-6 pl-2">
                                <v-switch
                                    v-if    = "isFullMaintenance && current.notIncludedInFullMaintenance"
                                    v-model = "data.invoice"
                                    label   = "Rechnung"
                                    @change = "onInvoice"
                                    class   = "mt-0 mb-2 pt-0"
                                    :class  = "incident.warrenties? 'pr-8' : ''"
                                    :ripple = "false"
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame" v-if="index === 0">
                            <v-col class="no-frame pr-2 col-6">
                                <msd-users
                                    v-model="incident.responsible"
                                    :background = "fileEntryFieldBackground"
                                />
                            </v-col>

                            <v-col class="no-frame pl-2 pr-2" v-if="isModernization">
                                <v-text-field
                                    v-if           = "collective"
                                    label          = "Projektnummer"
                                    v-model        = "data.projectnumber"
                                    :background-color = "fileEntryFieldBackground"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                                <v-text-field
                                    v-if           = "!collective"
                                    label          = "Projektnummer"
                                    v-model        = "current.projectnumber"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>

                            <v-col class="no-frame pl-2 col-6" v-if="!isModernization">
                                <f-date-picker
                                    label   = "inc.edit.common.executionDate"
                                    :time   = "false"
                                    v-model = "current.executionDate"
                                    class   = "w-100"
                                    :rules  = "[ requiredOnExecution ]"
                                />
                            </v-col>
                        </v-row>

                        <!-- Incident-level field, shown in every bids step (not only index 0); dense to fit the fixed-height column -->
                        <v-row class="no-frame">
                            <v-col class="no-frame pr-2 col-6">
                                <f-date-picker
                                    label             = "inc.edit.general.offerDate"
                                    :time             = "false"
                                    v-model           = "incident.offerDate"
                                    :background-color = "fileEntryFieldBackground"
                                    class             = "w-100 mb-2"
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame" v-if="isModernization">
                            <v-col class="no-frame pr-2" :class="isRebuild ? 'col-6  ' : 'col-12'">
                                <v-text-field
                                    v-if           = "collective"
                                    label          = "Auftragsnummer"
                                    v-model        = "data.ordernumber"
                                    :background-color = "fileEntryFieldBackground"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    @input         = "onOrdernumber"
                                />
                            </v-col>

                            <v-col class="no-frame pl-2" v-if="isRebuild">
                                <f-date-picker
                                    label   = "repair.modernization.warranty"
                                    :time   = "false"
                                    v-model = "data.warranty"
                                    class   = "w-100"
                                    :background-color = "fileEntryFieldBackground"
                                    :rules  = "[ requiredRule ]"
                                />
                            </v-col>
                        </v-row>

                        <inc-unit-down-interval
                            v-if      = "!previous && !isModernization"
                            :unitdata = "current"
                            :status   = "current.status"
                        />

                        <inc-processing-interval
                            v-if           = "!isModernization"
                            :data          = "data"
                            :status        = "current.status"
                            :background    = "fileEntryFieldBackground"
                            @start-changed = "validate"
                            @end-changed   = "validate"
                        />

                        <inc-processing-interval
                            v-if           = "isModernization"
                            :data          = "data"
                            :status        = "current.status"
                            :background    = "fileEntryFieldBackground"
                            label          = "repair.modernization.start"
                            label2         = "repair.modernization.end"
                            class="pr-2"
                            @start-changed = "validate"
                            @end-changed   = "validate"
                        />

                        <v-row class="no-frame" v-if="index !== 0">
                            <v-col class="no-frame pr-2 col-6">
                                <f-date-picker
                                    label   = "inc.edit.common.executionDate"
                                    :time   = "false"
                                    v-model = "current.executionDate"
                                    class   = "w-100"
                                    :rules  = "[ requiredOnExecution ]"
                                />
                            </v-col>
                            <v-col class="no-frame pl-2 col-6">
                                <v-switch
                                    v-if    = "isCollectivBidSelectable"
                                    v-model = "data.collective"
                                    label   = "Sammelangebot"
                                    class   = "mt-0 mb-2 pt-5 mr-2"
                                    :ripple = "false"
                                    @change = "onBidTypeChanged"
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-1 pr-2" v-if="data.tags.includes('description')">
                            <v-textarea
                                v-if           = "!previousCurrent"
                                label          = "Beschreibung"
                                v-model        = "current.description"
                                :rows          = "isModernization ? 5: 4"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"

                                no-resize
                            />
                            <v-textarea
                                v-if           = "previousCurrent && previousCurrent.description"
                                label          = "Beschreibung"
                                v-model        = "previousCurrent.description"
                                rows           = "4"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                no-resize
                            />
                        </v-row>
                        <v-row v-if="data.tags.includes('components')">
                            <inc-components
                                v-model       = "current.components"
                                :site         = "unit"
                                :warranties   = "warranties"
                                :incident     = "incident"
                                :status       = "status"
                                :height       = "isModernization ? 218 : 140"
                                :zoom-allowed = "true"
                                style         = "border-radius: 5px 0 5px 5px; margin-top: -1px"
                                @input        = "onComponents"
                                @zoom         = "onZoomComponents"
                                class         = "w-100 pr-2"
                            />
                        </v-row>
                        <v-row class="no-frame mt-5" v-if="!isModernization">
                            <v-col class="no-frame mr-2">
                                <v-text-field
                                    v-if           = "collective"
                                    label          = "Auftragsnummer"
                                    v-model        = "data.ordernumber"
                                    :background-color = "fileEntryFieldBackground"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    @input         = "onOrdernumber"
                                />
                                <v-text-field
                                    v-if           = "!collective"
                                    label          = "Auftragsnummer"
                                    v-model        = "current.ordernumber"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    @input         = "onOrdernumber"
                                />
                            </v-col>
                            <v-col class="no-frame ml-2" >
                                <f-read-only-field
                                    v-if  = "data.invoice && collective"
                                    label = "Rechnungsnummer"
                                    :value = "invoicenumber"
                                    collective
                                    dense
                                />
                                <f-read-only-field
                                    v-if  = "data.invoice && !collective"
                                    label = "Rechnungsnummer"
                                    :value = "invoicenumber"
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                    </div>
                </drop>
            </v-col>

            <v-col class="step-middle-column">
                <div v-if="!isBidsNecessary">
                    <v-row class="mt-11">
                        <inc-status
                            v-model = "current.status"
                            :items  = "fullMaintenanceStatus"
                            class   = "mt-0"
                            @change = "onStatusChanged"
                        />
                    </v-row>

                    <v-row class="mt-4">
                        <v-col class="no-frame ">
                            <c-contact-select
                                v-if        = "data.manufacturer"
                                v-model     = "data.contactIds"
                                label       = "Kontakte"
                                class       = "w-100"
                                :company-id = "data.manufacturer ? data.manufacturer.id : null"
                                :incident   = "incident"
                                :index      = "index"
                                :status     = "current.status"
                                @sendmail   = "onSendmail"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mt-5">
                        <v-col class="no-frame ">
                            <f-read-only-field
                                label  = "Email Ansprechpartner"
                                :value = "mntContact ? mntContact.name : null"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mt-3">
                        <v-textarea
                            v-model = "current.measure"
                            :rules  = "[requiredOnTerminationRule]"
                            :rows   = "4"
                            label   = "Maßnahme"
                            no-resize
                        />
                    </v-row>
                    <c-v-spacer />
                </div>

                <v-row class="no-frame" v-if="isBidsNecessary">
                    <inc-bid
                        :bid            = "bids[0]"
                        :incident       = "incident"
                        :data           = "data"
                        :status         = "step.status"
                        :sites          = "bidUnits"
                        :bus            = "bus"
                        :form           = "form"
                        :index          = "index"
                        :readonly       = "readonly"
                        :step           = "step"
                        @zoom           = "onZoom"
                        @status-changed = "onStatusChanged"
                        @refresh        = "onRefresh"
                        @sendmail       = "onBidMail"
                        @save           = "onSave"
                    />
                </v-row>
            </v-col>
            <v-col class="step-middle-column">

                <v-row class="mt-14" v-if="!isBidsNecessary">
                    <v-col class="no-frame ">
                        <f-title :title="$t('inc.edit.invoice.warranty')" class="mt-1"/>
                        <inc-warranty-edit
                            :site ="current"
                        />
                    </v-col>
                </v-row>


                <v-row class="no-frame" v-if="isBidsNecessary">
                    <inc-bid
                        :bid      = "bids[1]"
                        :incident = "incident"
                        :data     = "data"
                        :status   = "step.status"
                        :sites    = "bidUnits"
                        :bus      = "bus"
                        :form     = "form"
                        :index    = "index"
                        :readonly = "readonly"
                        :step     = "step"
                        @favorite = "onFavorite"
                        @refresh  = "onRefresh"
                        @zoom     = "onZoom"
                        @sendmail = "onBidMail"
                        @save     = "onSave"
                    />
                </v-row>
            </v-col>
            <v-col class="step-last-column">
                <v-row class="no-frame mb-1" v-show="!notice"  v-if="isBidsNecessary">
                    <v-carousel
                        v-model         ="currentBid"
                        :continuous     ="false"
                        :cycle          ="false"
                        :show-arrows    ="false"
                        :hide-delimiters="true"
                        height          ="100%"
                        class="pa-0 ma-0"
                        light
                    >
                        <v-carousel-item v-for="(bid, i) in bids.slice (2)" :key="i">
                            <v-sheet height="100%" tile>
                                <inc-bid
                                    :bid      = "bid"
                                    :incident = "incident"
                                    :data     = "data"
                                    :status   = "step.status"
                                    :sites    = "bidUnits"
                                    :bus      = "bus"
                                    :form     = "form"
                                    :index    = "index"
                                    :readonly = "readonly"
                                    :step     = "step"
                                    @favorite = "onFavorite"
                                    @refresh  = "onRefresh"
                                    @zoom     = "onZoom"
                                    @sendmail = "onBidMail"
                                    @status-changed = "onStatusChanged"
                                    @save     = "onSave"
                                >
                                </inc-bid>
                            </v-sheet>
                        </v-carousel-item>
                    </v-carousel>
                </v-row>

                <v-row
                    class="no-frame mt-0 bid-navigation "
                    v-show="!notice"
                    v-if="isBidsNecessary"
                >
                    <a v-for="(bid, i) in bids.slice (2)" :key="i"
                       class="delimiter primary"
                       :class="currentBid===i?'selected':''"
                       @click="currentBid=i">
                    </a>
                </v-row>

                <v-row class="bid-notice-column" v-show="notice">
                    <crm-journal
                        :incident="incident"
                        @front   ="onJournalFront"
                        @saved="success=true"
                    />
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Core                  from "@/modules/core/service/Core";
import Inb                   from "@/modules/inb/service/Inb";
import Inc                   from "@/modules/inc/service/Inc.js";
import Mail                  from "@/modules/inc/mail/service/Mail";
import FDatePicker           from "@/modules/core/components/utils/FDatePicker.vue";
import IncBid                from "@/modules/inc/steps/components/repair/private/IncBid.vue";
import CrmJournal            from "@/modules/crm/components/main/CrmJournal.vue";
import IncBidZoom            from "@/modules/inc/steps/components/repair/private/IncBidZoom.vue";
import {DragAwareMixin, Drop} from "vue-easy-dnd"
import IncStatus from "@/modules/inc/steps/components/common/IncStatus.vue";
import IncProcessingInterval from "@/modules/inc/steps/components/common/IncProcessingInterval.vue";
import IncComponents from "@/modules/inc/steps/components/common/IncComponents.vue";
import MsdUsers from "@/modules/msd/user/components/controls/MsdUsers.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import CVSpacer from "@/modules/core/components/utils/CVSpacer.vue";
import CContactSelect from "@/modules/msd/company/contact/components/controlls/CContactSelect.vue";
import IncUnitDownInterval from "@/modules/inc/steps/components/common/IncUnitDownInterval.vue";
import StepMixin from "@/modules/inc/steps/components/mixins/StepMixin";
import CDropMessage from "@/modules/inc/steps/components/common/CDropMessage.vue";
import FTitle from "@/modules/core/components/utils/FTitle.vue";
import IncWarrantyEdit from "@/modules/inc/warranty/IncWarrantyEdit.vue";
import IncSiteDownSwitch from "@/modules/inc/steps/components/common/IncSiteDownSwitch.vue";
import incWarranty from "@/modules/inc/warranty/IncWarranty.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
export default {
    name: "IncBids",

    mixins: [
        StepMixin,
        DragAwareMixin
    ],

    components: {
        CToolbarButton,
        IncSiteDownSwitch,
        IncWarrantyEdit,
        FTitle,
        CDropMessage,
        IncUnitDownInterval,
        CContactSelect,
        CVSpacer,
        FReadOnlyField,
        MsdUsers,
        IncComponents,
        IncProcessingInterval,
        IncStatus,
        CrmJournal,
        IncBid,
        IncBidZoom,
        Drop,
        FDatePicker,
    },

    props: {
        incident: {

        },

        data: {
            required: false,
            type    : Object,
            default : function () {
                return {
                    notIncludedInFullMaintenance: false,
                }
            }
        },

        changes: {
            type: Function,
        },

        bus: {

        },

        step: {

        },

        index: {

        },

        readonly: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        drag: {
            notAllowed: false,
            message   : null
        },

        notice : false,
        zoom   : false,
        zoomComponents: false,
        selected: null,
        refresh : 0,
        components: null,
        currentBid: 0,
        collective: true,
        event: null,
    }),

    computed: {
        incWarranty() {
            return incWarranty
        },
        requiredRule () {
            return Core.rule.required;
        },

        previous () {
            if (this.index === 0) {
                return null;
            }

            return this.incident.data[0];
        },

        previousCurrent () {
            const previous = this.previous;
            if (!previous) {
                return null;
            }

            return previous.collection.find(d => d.unit.id === this.unit.id);
        },

        invoice () {
            return this.incident.data[this.index+1];
        },

        invoicenumber () {
            if (this.isModernization) {
                return null;
            }

            return this.invoice.invoicenumber;
        },

        isFullMaintenance() {
            return Inc.isFullMaintenance(this.incident);
        },

        isModernization () {
            return this.incident && (this.incident.typeId === 23 || this.incident.typeId === 24);
        },

        isRebuild () {
            return this.incident && this.incident.typeId === 23;
        },

        isCollectivBidSelectable () {
            const units = this._stepUnits();
            if (units.length <= 1) {
                return false;
            }

            return !this.isFullMaintenance || this.current.notIncludedInFullMaintenance;
        },

        isBidsNecessary () {
            return Inc.isBidsNecessary(this.incident, this.current) || this.isModernization;
        },

        mntContact () {
            if (!this.incident.sites[0].mntContact) {
                return null;
            }

            return this.incident.sites[0].mntContact.email;
        },

        fullMaintenanceStatus () {
            return this.step.status.filter (s => [1,3,4,2,5,33].includes(s.id));
        },

        units () {
            return this._stepUnits();
        },

        bidUnits () {
            if (this.collective ) {
                return this.units;
            }

            return [ this.unit ];
        },

        status () {
            if (this.bids[0] && this.bids[0].status) {
                return this.bids[0].status;
            }

            return this.current.status
        },

        bids () {
            if (!this.unit) {
                return null;
            }


            if (this.collective || this.data.collective) {
                return this.data.bids;
            }

            const repair = this.data.collection.find (s => s.unit.id === this.unit.id);
            if (!repair) {
                return null;
            }

            return repair.bids;
        },

        fileEntryFieldBackground () {
            return Inc.style.fileEntryFieldBackground(this.data);
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        noticeOn () {
            return this.preferences.noticedisplaymode;
        },

        warranties() {
            if (!this.incident.warrenties) {
                return [];
            }

            return this.incident.warrenties.find(w => w.unit.id === this.unit.id);
        },
    },


    created() {
        this.form   = this.$parent;
        this.freeze = JSON.stringify(this.data);
        this.$bus.$on(this.$events.drag.end, this.onDragend);
        this.bus.$on (Inc.events.notice, (show) => {
            this.notice = show;
        });
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.drag.end, this.onDragend);
    },

    mounted() {
        this.form = this.$parent;
        this.$nextTick(() => {
            this.form.validate();
            this.collective = this.data.collective;
            if (this.noticeOn || this.isFullMaintenance) {
                this.notice = true;
                this.$emit("notice", true)
            }
            this.initBase();
        });
    },

    watch: {
        data () {
            this.collective = this.data.collective;
            if (this.noticeOn || this.isFullMaintenance) {
                this.notice = true;
                this.$emit("notice", true)
            }
        }
    },


    methods: {
         _validate () {
             if (!this.data.visible || !this.unit) {
                 return;
             }

             this.current.valid = this.form.validate();
         },

         /**
          * Sets the given unit als new context for the processing step. The visibility of other processing steps and
          * will be adopted to the given unit.
          *
          * @param unit the new unit context.
          */
         _setContext (unit) {
             this.unit = unit;
             if (this.isModernization) {
                 return;
             }

             if (!this.previousCurrent || Inc.status.terminatedWithRepair.includes (this.previousCurrent.status.id)) {
                 this.invoice.visible = this.data.invoice;
                 return;
             }

             this.invoice.visible = false;
         },

         /**
          * Checks if the current processing step in the current context is terminated.
          * @returns true, if the processing step is terminated, false otherwise.
          */
         _isTerminated () {
             if (!this.bids || this.bids.length === 0) {
                 return false;
             }

             return this.bids[0].status.type === 'T';
         },

         _status () {
             if (this.isFullMaintenance && this.current && !this.current.notIncludedInFullMaintenance) {
                return this.current.status;
             }

             if (!this.bids || this.bids.length === 0) {
                 return null;
             }

             return this.bids[0].status;
         },

         /**
          * Force an update of relevat componets. E.g. when the list of assigned sites changes.
          */
         _forceUpdate () {
             this.freeze = JSON.stringify(this.data);
             this.refresh ++;
         },

         _unitStepStatus (unit) {
             const current = this.data.collection.find (s => s.unit.id === unit.id);
             if (!current) {
                 return null;
             }

             if (this.previous) {
                 const current = this.previous.collection.find(d => d.unit.id === unit.id);
                 if (!Inc.status.terminatedWithRepair.includes (current.status.id)) {
                     return null;
                 }
             }

             return current.valid ? "success" : "error";
         },

         /**
          * Validate the processing step and inform the main dialog about a possible change.
          */
         validate () {
             this.form = this.$parent;
             this.form.validate ();
             return Promise.resolve();
         },

         onBidTypeChanged (value) {
             const query = value ? "repair.bid.changeToCollective.query" : "repair.bid.changeToSeparated.query";
             const text  = value ? "repair.bid.changeToCollective.text"  : "repair.bid.changeToSeparated.text";

             Core.message.confirm(
                 this,
                 this.$t(query),
                 this.$t(text),
                 Core.message.Default,
                 (value) => {
                     if (!value) {
                         this.$nextTick(() => {
                             this.data.collective = this.collective;
                         })
                         return;
                     }

                     this.$nextTick(() => {
                         this.$emit("save", () => {
                             this.collective = this.data.collective;
                         });
                     })
                 }
             );
         },

         onRefresh (message) {
             this.$emit("refresh", message);
         },

         onSave (success) {
             this.$emit("save", success);
         },

         /**s
          * Checks whether a message can be attached to the current processing step.
          * @param message the message
          * @return true, if the message can be attached to the step.
          */
         onAcceptType (message) {
             const pos  = this.dragPosition;
             if (!this.contains(pos.x, pos.y)) {
                 this.drag.notAllowed = false;
                 return false;
             }

             if (message === "dms-document") {
                 return true;
             }

             if (!(message instanceof Object) || message.type === "dms-document") {
                 return;
             }

             const accept = Inc.clipboard.accept(message, this.incident, [{
                 message : "REPAIR",
                 incident: null
             }, {
                 message: "INCIDENT",
                 incident: null
             }, {
                 message : "WORKREPORT",
                 incident: null
             }, {
                 message : "ORDER",
                 incident: null
             }, {
                 message : "ORDERPLACEMENT",
                 incident: null
             }, {
                 message : "DEFAULT",
                 incident: null
             }, {
                 message: "WORKREPORT",
                 incident: null
             }, {
                 message: "IMAGE",
                 incident: null
             },{
                 message: "CORRESPONDENCE",
                 incident: null
             },
             ], true, false);

             this.drag.notAllowed = !accept.valid;
             this.drag.message    = this.$t(accept.message);

             return accept.valid;
         },

         /**
          * Attaches a message to the processing step.
          * @param event the drag'n drop element that contains the message,
          */
         onDrop (event) {
             switch (event.data.type) {
                 case 'clipboard':
                     Inc.clipboard.paste (this, event.data.data.id, event.data.data.unit, this.incident.id, this.changes());
                     break;
                 case 'inbox':
                     Inb.attach(this, event.data.data.id, this.incident.id, this.step, null, true, (data) => {
                         this.$emit("refresh", data);
                     });
             }
         },

         onDragend () {
             this.drag.notAllowed = false;
         },

         onInvoice () {
             this.invoice.visible = this.data.invoice;
             if (this.data.invoice) {
                 this.invoice.beginDate = this.data.endDate;
             }
         },

         onComponents (components) {
             this.data.components = components;
             this.validate().then (() => {
                 this.$emit("validated")
             })
         },

        onZoomComponents () {
            this.zoomComponents = true;
        },

         onOrdernumber () {
             this.$emit("sync", {
                 index: this.index + 1,
                 name : "ordernumber",
                 value: this.data.ordernumber
             } );
         },

         display () {
             this.collective = this.data.collective && this.data.collection.length > 1;

             if (this.index === 0) {
                 return;
             }

             if (!this.data.beginDate) {
                this.data.beginDate = this.incident.data[this.index-1].endDate;
                if (this.index > 1 && !this.data.beginDate) {
                    this.data.beginDate = this.incident.data[this.index-2].endDate;
                }
             }

             if (!this.previousCurrent) {
                 return;
             }

             if (!this.current.components || this.current.components.length === 0) {
                 this.current.components = JSON.parse(JSON.stringify(this.previousCurrent.components));
             }
        },

         async getMail () {
             return Mail.initialize(this.incident.sites, this.index, this.data, this.current, this.incident, this.step);
         },

         onSendmail (mail) {
             mail.step = this.step.id;
             this.$emit("sendmail", mail);
         },

         onBidMail (mail) {
             mail.step = this.step.id;
             this.$emit("sendmail", mail);
         },

         onFavorite (bidname) {
            const bids = this.data["bids"];
            bids.map (bid => bid.favorite=false);
            bids.forEach(function(item,i){
                if(item["bidname"] === bidname){
                    bids.splice(i, 1);
                    item.favorite = true;
                    bids.unshift(item);
                }
            });
        },

        onZoom (bid) {
            this.selected = bid;
            this.zoom = true;
            this.validate().then (() => {
                this.$emit("validated")
            })
        },

        onCloseZoom (calculations) {
            this.zoom = false;
            this.selected.calculations = calculations;
        },

         onNotIncludedInFullMaintenance () {
             if (this.current.notIncludedInFullMaintenance) {
                 this.data.invoice = true;
                 this.invoice.visible = true;
             } else {
                 this.data.invoice = false;
                 this.invoice.visible = false;
             }

             this.validate().then (() => {
                 this.$emit("validated")
             })
         },

        requiredOnTerminationRule (value)  {
            if (Inc.step.canceled(this.current.status)) {
                return true;
            }

            return Core.rule.requiredOnTermination(value, this.current.status);
        },

         requiredOnExecution (value)  {
             if (Inc.step.canceled(this.current.status)) {
                 return true;
             }

             if (!this.current) {
                 return true;
             }
             return Core.rule.requiredOnStatus(value, this.current.status, 2);
         },

         contains (x, y) {
             const rect = this.$refs.droparea.$el.getBoundingClientRect();
             return rect.x <= x && x <= rect.x + rect.width &&
                 rect.y <= y && y <= rect.y + rect.height;
         },

         _stepUnits() {
            return Inc.step.units(this.data);
        },
     }
}
</script>

<style scoped>

.delimiter {
    width: 25px;
    height: 8px;
    margin-right: 10px;
    opacity: 0.3
}

.selected {
    opacity: 1!important;
}

.component-zoom-panel {
    position: absolute;
    width: calc(50% - 4px);
    background-color: white;
    z-index: 10;
}

.component-close-button {
    position: absolute;
    z-index: 11;
    right: 14px;
    top: 8px;
}

.bid-notice-column {
    margin-top: 0;
}

.bid-navigation {
    justify-content: center;
    position: absolute;
    bottom: 7px;
    right: 6%;
}


</style>